import axiosInstance from "../../../helpers/axiosInstance";
import {
  LOGIN_ERROR,
  LOGIN_LOADING,
  LOGIN_SETUSUARIO,
  LOGIN_SUCCESS,
  LOGOUT_USER,
} from "../../ActionTypes";

export const setUsuarioAuth = (usuario) => (dispatch) => {
  if (usuario !== null) {
    sessionStorage.token = usuario.token;
  }
  dispatch({
    type: LOGIN_SETUSUARIO,
    payload: usuario,
  });
};

// export const login =
//   ({ txtDni, txtPassword }, sector, nextStep) =>
//   (dispatch) => {
//     dispatch({
//       type: LOGIN_LOADING,
//     });

//     axiosInstance().then((respuesta) => {
//       respuesta
//         // .post("/auth", {
//         .post("/authAutoterminal", {
//           password: txtPassword,
//           nro_documento: txtDni,
//           idTerminal: sector,
//         })
//         .then((res) => {
//           sessionStorage.token = res.data.token;
//           dispatch({
//             type: LOGIN_SUCCESS,
//             payload: res.data,
//           });
//           if (nextStep) {
//             nextStep(true, res.data);
//           }
//         })
//         .catch((err) => {
//           let error = {
//             detail: err.response
//               ? err.response.data
//               : "Error al contactar el server.",
//             origen: "portal",
//           };

//           dispatch({
//             type: LOGIN_ERROR,
//             payload: error,
//           });
//           if (nextStep) nextStep(false, error);
//         });
//     });
//   };

export const login =
  ({ txtDni }, nextStep) =>
  (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        // .post("/auth", {
        .post("/authCheckinQr", {
          nro_documento: txtDni,
        })
        .then((res) => {
          sessionStorage.token = res.data.token;
          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          });
          if (nextStep) {
            nextStep(true, res.data);
          }
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: LOGIN_ERROR,
            payload: error,
          });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const loginApp =
  ({ txtDni, txtPassword }, sectorTurno, nextStep) =>
  (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .post("/auth", {
          // .post("/authAutoterminal", {
          password: txtPassword,
          nro_documento: txtDni,
          sectorTurno,
        })
        .then((res) => {
          // sessionStorage.token = res.data.token;
          // dispatch({
          //   type: LOGIN_SUCCESS,
          //   payload: res.data,
          // });
          if (nextStep) {
            nextStep(true, res.data);
          }
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          // dispatch({
          //   type: LOGIN_ERROR,
          //   payload: error,
          // });
          if (nextStep) nextStep(false, error);
        });
    });
  };

// export const login = ({ txtDni, txtPassword }, sector, nextStep) => (dispatch) => {
//   dispatch({ type: FILAVIRTUAL });

//   axiosAutoCheck().then((respuesta) => {
//     respuesta
//       .post(`/FilaVirtual/`, filaVirtualDto)
//       .then((resp) => {
//         dispatch({ type: FILAVIRTUAL_SUCCESS, payload: resp.data });
//         if (nextStep) nextStep(true);
//       })
//       .catch((err) => {
//         dispatch({ type: FILAVIRTUAL_FAIL, payload: err.response.data });
//         if (nextStep) nextStep(false);
//       });
//   });
// };

export const logoutAuth = () => (dispatch) => {
  dispatch({ type: LOGOUT_USER });
};

export const wsGetAuthToken = (token, nexStep) => (dispatch) => {
  dispatch({
    type: LOGIN_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/authtoken/${token}`)
      .then((res) => {
        sessionStorage.token = res.data.token;
        dispatch({
          type: LOGIN_SUCCESS,
          payload: res.data,
        });
        if (nexStep) {
          nexStep(true, res.data);
        }
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: LOGIN_ERROR,
          payload: error,
        });
        if (nexStep) {
          nexStep(false, err);
        }
      });
  });
};

export const wsPostTokenValidation =
  (idApp, history, set, idPaciente, to, sectorTurno) => (dispatch) => {
    set(true);
    sessionStorage.setItem("idApp", idApp);

    axiosInstance().then((respuesta) => {
      respuesta
        .post(`/authAuto`, {
          id: Number(idPaciente),
          descripcion: idApp,
          sectorTurno: sectorTurno,
        })
        .then((resp) => {
          dispatch({ type: LOGIN_SUCCESS, payload: resp.data });
          if (resp.data.token) {
            sessionStorage.setItem("token", resp.data.token);
            sessionStorage.setItem("auth", JSON.stringify(resp.data));
            set(false);
            history.push(to);
          } else {
            set(false);
          }
        })
        .catch((err) => {
          set(false);
        });
    });
  };

export const wsPostLoginSegundoFactor =
  ({ txtUsuario, txtPassword }) =>
  (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .post("/authUsuario", {
          usuario: txtUsuario,
          password: txtPassword,
        })
        .then((res) => {
          sessionStorage.token = res.data.token;
          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: LOGIN_ERROR,

            payload: error,
          });
        });
    });
  };
